<template>
<!-- 夜勤コンポーネント(子) -->
<div id="nightwork">
  <p style="margin-bottom: 3px; width: 60px; text-align:center;">
    <span>{{ nights[index] }}</span>
    <input type="hidden" :value="nightWork" />
  </p>
</div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'NightWork',
  data() {
    return {
      nights: []
    }
  },
  props: {
    monthDay: Array,
    start: Array,
    end: Array,
    rest: Array,
    nightRest:Array,
    attendance1: Array,
    index: Number,
    earlyMorningShiftBasic:String,
    lateNightShiftBasic:String,
    midnightBasic:String,
    nightShiftTimes:String,
    dateChangeShiftTimes:String,
  },
  computed: {
    // 夜勤の自動計算
    nightWork: function () {
      const list = this.nights;
      for (let i = 0; i < this.start.length; i++) {
        // 開始時刻、終了時刻が未記入の場合はnullを設定
        if(this.start[i] == null || this.end[i] == null || this.start[i] == '' || this.end[i] == ''){
          list.splice(i, 1, null);
          continue;
        }
        //開始時刻
        const sTime = moment.duration(this.start[i], 'HH:mm')
        //終了時刻
        const eTime = moment.duration(this.end[i], 'HH:mm')
        //5:00(早朝勤務規定時間)
        const emsBasic = moment.duration(this.earlyMorningShiftBasic, 'HH:mm')
        //22:00(夜勤勤務規定時間)
        const lnsBasic = moment.duration(this.lateNightShiftBasic, 'HH:mm')
        //夜勤休憩時間
        const nightRest = moment.duration(this.nightRest[i], 'HH:mm') 
        //24:00（日付変更時間）
        const mnBasic = moment.duration(this.midnightBasic, 'HH:mm')
        //0:00~5:00まで勤務
        const nsTimes = moment.duration(this.nightShiftTimes, "HH:mm")
        //22:00~24:00までの勤務
        const dcsTimes = moment.duration(this.dateChangeShiftTimes, "HH:mm")

        //未記入部分は00:00
        if ((sTime.hours() === 0)&&(eTime.hours() === 0)&&(nightRest.hours() === 0)) {
          list.splice(i, 1, null)
          continue
        }

        //夜勤時間の計算結果格納変数
        let calculateTime = moment.duration(0, 'HH:mm');
        // 夜勤時間の初期値
        let nightHours = '00';
        let nightMinutes = '00';
   
        //日付をまたぐ勤務になるかの判断
        //日付をまたがない場合（終了時刻＞開始時刻）
        if(eTime.hours() > sTime.hours()){
          //夜勤勤務にならない場合（5:00〜21:59勤務）
          if(((sTime.hours() >= 5) && (sTime.hours() < 22)) && ((eTime.hours() >= 5) && (eTime.hours() < 22))){
            list.splice(i, 1, null)
            continue
          }
          //夜勤勤務にならない場合（5:00〜21:59の間に開始、22:00に終了）
          if(((sTime.hours() >= 5) && (sTime.hours() < 22)) && ((eTime.hours === 22) && (eTime.minutes() === 0))){
            list.splice(i, 1, null)
            continue
          }
          //早朝に開始、夜勤に終了(開始時刻<5:00）かつ（終了時刻>=22）
          if((sTime.hours() < 5) && (eTime.hours() >= 22)){
            emsBasic.subtract(sTime, 'HH:mm') 
            eTime.subtract(lnsBasic, 'HH:mm')
            emsBasic.add(eTime, 'HH:mm')
            emsBasic.subtract(nightRest, 'HH:mm')
            if(emsBasic <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = emsBasic;
          }
          //早朝に開始、早朝に終了（開始時刻<5:00）かつ（終了時刻<5:00）、または、夜勤に開始、夜勤に終了（開始時刻>=22）かつ（終了時刻>=22）
          else if(((sTime.hours() < 5) && (eTime.hours() < 5))||((sTime.hours() >= 22) && (eTime.hours() >= 22))){
            eTime.subtract(sTime, 'HH:mm')
            eTime.subtract(nightRest, 'HH:mm')
            if(eTime <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = eTime;
          }
          //終了時間夜勤時間（終了時刻>=22）
          else if (eTime.hours() >= 22) {
            eTime.subtract(lnsBasic, 'HH:mm')
            eTime.subtract(nightRest, 'HH:mm')
            if(eTime <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = eTime;
          }
          //開始時刻が夜勤時間（開始時刻<5）
          else if (sTime.hours() < 5) {
            emsBasic.subtract(sTime, 'HH:mm')
            emsBasic.subtract(nightRest, 'HH:mm')
            if(emsBasic <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = emsBasic;
          }
        }
        //日付をまたぐ場合（開始時刻>=終了時刻）
        else if (sTime.hours() >= eTime.hours()) {
          //夜勤に業務開始・早朝に業務終了（開始時刻>=22）かつ（終了時刻<5）
          if ((sTime.hours() >= 22) && (eTime.hours() < 5)) {
            mnBasic.subtract(sTime, 'HH:mm')
            mnBasic.add(eTime, 'HH:mm')
            mnBasic.subtract(nightRest, 'HH:mm')
            if(mnBasic <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = mnBasic;
          }
          //早朝に業務開始、翌日の早朝に業務終了、24時間は経っていない（開始時刻<5）かつ（終了時刻<5）
          else if ((sTime.hours() < 5) && (eTime.hours() < 5)) {
            emsBasic.subtract(sTime, 'HH:mm')
            dcsTimes.add(eTime, 'HH:mm')
            dcsTimes.add(emsBasic, 'HH:mm')
            dcsTimes.subtract(nightRest, 'HH:mm')
            if(dcsTimes <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = dcsTimes;
          }
          //夜勤に業務開始、翌日の夜勤に業務終了、24時間は経っていない（開始時刻>=22)かつ（終了時刻>=22）
          else if ((sTime.hours() >= 22) && (eTime.hours() >= 22)) {
            mnBasic.subtract(sTime, 'HH:mm')
            mnBasic.add(nsTimes, "HH:mm")
            eTime.subtract(lnsBasic, "HH:mm")
            mnBasic.add(eTime, 'HH:mm')
            mnBasic.subtract(nightRest, 'HH:mm')
            if(mnBasic <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = mnBasic;
          }
          //夜勤に業務開始、通常時間に業務終了（開始時刻>=22）かつ（終了時刻>=5)
          else if ((sTime.hours() >= 22) && (eTime.hours() >= 5)) {
            mnBasic.subtract(sTime, "HH:mm")
            mnBasic.add(nsTimes, "HH:mm")
            mnBasic.subtract(nightRest, 'HH:mm')
            if(mnBasic <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = mnBasic;
          }
          //通常時間帯に業務開始、早朝に業務終了（開始時刻<22）かつ（終了時刻<5)
          else if ((sTime.hours() < 22) && (eTime.hours() < 5)) {
            eTime.add(dcsTimes, "HH:mm")
            eTime.subtract(nightRest, 'HH:mm')
            if(eTime <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = eTime;
          }
          //通常時間帯に業務開始、業務終了{(開始時刻>5)かつ（開始時刻<=22)}かつ{(終了時刻>5)かつ（終了時刻<=22)}
          else if (((sTime.hours() >= 5) && (sTime.hours() < 22)) && ((eTime.hours() >= 5) && ((eTime.hours() <= 22) || ((eTime.hours() === 22) && (eTime.hours() === 0))))) {
            nsTimes.add(dcsTimes, "HH:mm")
            nsTimes.subtract(nightRest, 'HH:mm')
            if(nsTimes <= 0){
              list.splice(i, 1, null)
              continue
            }
            calculateTime = nsTimes;
          }
        }
        nightHours = calculateTime.hours() < 10 ? '0' + calculateTime.hours() : calculateTime.hours();
        nightMinutes = calculateTime.minutes()< 10 ? '0' + calculateTime.minutes() : calculateTime.minutes();
        list.splice(i, 1, nightHours + ':' + nightMinutes);
      }
      return list;
    }
  },
  watch: {
    nightWork: {
      immediate: true,
      handler(newVal) {
        this.$emit('updateNightTime', {
          nights: this.nights,
          index: this.index,
          value: newVal[this.index]
        });
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
